module.exports = __webpack_public_path__ + "static/2016-5933-c5829c7906fd68a236d70f29ab05ecb1.jpg";